var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 5.95825H15.1667C15.7413 5.95825 16.2924 6.18653 16.6987 6.59285C17.1051 6.99918 17.3333 7.55028 17.3333 8.12492V13.5416C17.3333 14.1162 17.1051 14.6673 16.6987 15.0736C16.2924 15.48 15.7413 15.7083 15.1667 15.7083H9.75L5.95833 18.9583V15.7083H3.25V5.95825Z",
    stroke: "currentColor",
    strokeWidth: 1.84167,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5415 15.1667V15.7083C13.5415 16.283 13.7698 16.8341 14.1761 17.2404C14.5824 17.6467 15.1335 17.875 15.7082 17.875H19.4998L22.2082 20.5833V17.875C22.5516 17.4856 22.7439 16.9858 22.7498 16.4667V11.9167C22.7498 11.342 22.5216 10.7909 22.1152 10.3846C21.7089 9.97827 21.1578 9.75 20.5832 9.75H18.4165",
    stroke: "currentColor",
    strokeWidth: 1.84167,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.bd7b6dc1608c11d79e85cae664901ab1.svg";
export { ForwardRef as ReactComponent };